import { reactive } from "vue";

export const examStore = reactive({
    examMap: new Map(),
    currentExamKey: "",
    randomCount: 0,

    setExamData(content) {
        const self = this;

        let checkExamData = function (element) {
            let examData = (element.examCount && element.examPath)
                ? {
                    count: element.examCount,
                    path: element.examPath
                }
                : null;

            return examData;
        }

        let gF = function (pageTag, data, examData) {
            if (data.child.length > 0) {
                data.child.forEach(element => {
                    gF(pageTag, element, examData || checkExamData(element));
                });
            } else {
                if (examData) {
                    self.examMap.set(`${pageTag}_${data.pageIndex}`, examData);
                }
            }
        }

        content.forEach(element => {
            gF(element.pageTag, element, checkExamData(element));
        });
    },
    hasExam() {
        return this.examMap.has(this.currentExamKey);
    },
    getExamData() {
        return this.examMap.get(this.currentExamKey);
    },
    getRandomExam() {
        const self = this;
        const getRandomInt = function () {
            return 1 + Math.floor(Math.random() * self.getExamData().count)
        }
        const getRandomIntArray = function () {
            let result = [];
            let count = 0;


            while (result.length !== Number(self.randomCount)) {
                count++;

                let value = getRandomInt();

                if (!result.includes(value)) {
                    result.push(value);
                }

                if (count >= 20000) {
                    break;
                }
            }
            console.log(result)
            return result;
        }

        return getRandomIntArray();
    },
    setExamKey(key) {
        this.currentExamKey = key;
    }
});